import React from 'react';
import styles from './EstateManage.module.scss';
import icons from '../../assets/images/icons';

/**
 * 소유자 인증 안내 모달
 * - "소유자 인증" 컬럼 헤더의 ? 아이콘 또는 배너 클릭 시 표시
 */
function OwnerVerificationInfoModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div className={styles.ovInfoOverlay} onClick={handleOverlayClick}>
      <div className={styles.ovInfoModal}>
        <div className={styles.ovInfoClose}>
          <button
            type="button"
            className={styles.ovInfoCloseBtn}
            onClick={onClose}
            aria-label="닫기"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="#171719" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className={styles.ovInfoImage}>
          <img src={icons.ownerVerification.info} alt="소유자 인증 안내" />
        </div>

        <div className={styles.ovInfoContent}>
          <h2 className={styles.ovInfoTitle}>
            소유자 인증하고{'\n'}광고 효과를 극대화해 보세요
          </h2>
          <p className={styles.ovInfoDesc}>
            인증된 매물은 {'\n'}거래 성사율 상승에 도움이 됩니다
          </p>
        </div>

        <div className={styles.ovInfoAction}>
          <button
            type="button"
            className={styles.ovInfoConfirmBtn}
            onClick={onClose}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default OwnerVerificationInfoModal;
